export const MAIL_API_PATHS = {
    SEND_EMAIL: '/sendEmail',
};
